import '../kickstart';

import { h, render } from 'preact';
import App from '../App';

/**
 * Your code belongs here.
 */

const shell = document.getElementById('shell');

render(<App />, shell, shell.firstElementChild);
